export const CUSTOM_EVENTS = {
  cookieConsentUpdated: 'cookie_consent_updated',
  openCookiePreferences: 'open_cookie_preferences',
  regionChanged: 'region_changed',
} as const;
